module.exports = __webpack_public_path__ + "img/ico-arrow-down.89e1205f.svg";